export const FLUID = 'pageSet/fluid';
export const MODERN_CLASSIC = 'pageSet/modernClassic';
